export default [
    { image: "images/logos/samsung.png" },
    { image: "images/logos/LG.png" },
    { image: "images/logos/mi.png" },
    { image: "images/logos/ifb.png" },
    { image: "images/logos/whirlpool.png" },
    { image: "images/logos/daikin.png" },
    { image: "images/logos/sony.png" },
];
